import React from "react";

const Skeleton = ({ children, width = "fit-content", isLoaded }) => {
  if (isLoaded) {
    return children;
  }
  return (
    <span className="skeleton" aria-hidden="true" style={{ width }}>
      {children}
    </span>
  );
};

export default Skeleton;
